<template>
    <rkm-modal
        ref="RkmModal"
        title="Telefone principal do paciente"
    >
        <Form
            :data="{model}"
            @saved="saved"
            ref="Form"
        />

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="$refs.Form.save()"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Mixins.
import {object} from '@/mixins'

export default {
    components: {Form},
    computed: {
        validations() {
            return {
                telefone: {
                    required: true,
                    min_max_without_mask: [10, 11],
                },
            }
        },
    },
    data: () => ({
        item: null,
        model: null,
    }),
    methods: {
        open(item) {
            this.item = item

            this.edit()

            this.$refs.RkmModal.show()
        },
        edit() {
            this.model = this.clone({
                telefoneNumero: this.item.telefoneNumero,
                telefoneAutorizaSms: this.item.telefoneAutorizaSms,
            })
        },
        update() {
            Object.assign(this.item, this.model)
        },
        saved() {
            this.item.telefoneAtualizado = true
            this.update()
            this.$refs.RkmModal.hide()
        },
    },
    mixins: [object],
}
</script>
